import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const FilePlist = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.5 4.5V2.5L2.5 2.5L2.5 13.5H10.5V11.5H12V13.5C12 14.3284 11.3284 15 10.5 15H2.5C1.67157 15 1 14.3284 1 13.5V2.5C1 1.67157 1.67157 1 2.5 1H10.5C11.3284 1 12 1.67157 12 2.5V4.5H10.5Z"
      fill="currentColor"
    />
    <path
      d="M11.1221 7.76281C11.3612 7.83828 11.5553 7.8995 11.5553 8.0473C11.5553 8.20946 11.4134 8.35135 11.1904 8.35135C10.8255 8.35135 10.5823 8.0473 10.5823 8.0473L10.1363 8.51351C10.1363 8.51351 10.5215 9 11.2715 9C11.9809 9 12.4066 8.57432 12.4066 8.06757C12.4066 7.45547 11.9062 7.29757 11.5222 7.17638C11.2831 7.10091 11.089 7.03969 11.089 6.89189C11.089 6.77027 11.2107 6.64865 11.3931 6.64865C11.6728 6.64865 11.8593 6.87162 11.8593 6.87162L12.3053 6.40541C12.3053 6.40541 12.0012 6 11.312 6C10.6634 6 10.2377 6.42568 10.2377 6.87162C10.2377 7.48371 10.7381 7.64162 11.1221 7.76281Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.87712 6.08108H3.6001V8.91892H4.37037V8.06757H4.87712C5.5055 8.06757 5.93118 7.64189 5.93118 7.07432C5.93118 6.50676 5.5055 6.08108 4.87712 6.08108ZM4.37037 6.77027H4.83658C5.01902 6.77027 5.16091 6.91216 5.16091 7.07432C5.16091 7.23649 5.01902 7.37838 4.83658 7.37838H4.37037V6.77027Z"
      fill="currentColor"
    />
    <path d="M6.45452 8.91892H8.48155V8.22973H7.22479V6.08108H6.45452V8.91892Z" fill="currentColor" />
    <path d="M8.92381 8.91892V6.08108H9.69408V8.91892H8.92381Z" fill="currentColor" />
    <path d="M12.6462 6.08108H14.9975V6.77027H14.207V8.91892H13.4367V6.77027H12.6462V6.08108Z" fill="currentColor" />
  </Icon>
));

export default FilePlist;
